export default "__VITE_ASSET__Cgbmbecn__"